//  ----------      START   IMPORT  BLOCK       ----------
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
//  Icons
import logo from '../../../../../Assets/Images/cleir_logo.png';
//  Config
import VocabFooter from '../../../../../ConfigFiles/multilingual/VocabFooter.js';
import { FRONTEND_ROUTES } from "../../../../../ConfigFiles/Routes/frontend_routes.js";
//  ----------      END   IMPORT  BLOCK       ----------

export const footerConfig = (lan) => ({
  columns: [
    {
      title: VocabFooter.professionals[lan],
      links: [
        { text: VocabFooter.faq[lan], href: FRONTEND_ROUTES.professionals_faq},
        { text: VocabFooter.help[lan], href: FRONTEND_ROUTES.professionals_help},
        { text: VocabFooter.privacy[lan], href: FRONTEND_ROUTES.professionals_privacy},
      ],
    },
    {
      title: VocabFooter.patients[lan],
      links: [
        { text: VocabFooter.faq[lan], href: FRONTEND_ROUTES.patients_faq},
        { text: VocabFooter.help[lan], href: FRONTEND_ROUTES.patients_help},
        { text: VocabFooter.privacy[lan], href: FRONTEND_ROUTES.patients_privacy},
      ],
    },
    {
      title: VocabFooter.companny_title[lan],
      links: [
        { text: VocabFooter.about[lan], href: FRONTEND_ROUTES.about_company},
        { text: VocabFooter.news[lan], href: FRONTEND_ROUTES.about_news},
        { text: VocabFooter.staff[lan], href: FRONTEND_ROUTES.about_staff},
        { text: VocabFooter.jobs[lan], href: FRONTEND_ROUTES.about_jobs},
        { text: VocabFooter.contact[lan], href: FRONTEND_ROUTES.about_contact},
      ],
    },
    {
      logo: logo,
      address: VocabFooter.address[lan],
      socials: [
        { icon: <FaFacebookF />, href: FRONTEND_ROUTES.socials_facebook },
        { icon: <FaTwitter />, href: FRONTEND_ROUTES.socials_twitter },
        { icon: <FaInstagram />, href: FRONTEND_ROUTES.socials_instagram },
      ],
    },
  ],
  bottomText: VocabFooter.copyright[lan],
});
